module.exports = __webpack_public_path__ + "static/media/btbms_desktop_hero_fr.24c06684.jpg";